import { Box } from '@mui/material';
import PrimarySearchAppBar from '../components/PrimarySearchAppBar';
import { ResultJSON } from '../components/ResultJSON';
import { useParams } from 'react-router-dom';
import { FIPOKTableAndRadar } from '../components/FIPOKTableAndRadar';

export const ResultPage = () => {
	const { code } = useParams() as { code: string };

	return (
		<Box
			display='flex'
			flexDirection='column'
			width='100vw'
			height='100vh'
		>
			<PrimarySearchAppBar/>
			<ResultJSON code={code}>
				<FIPOKTableAndRadar section="measuredCognitiveValues" title="Measured Cognitive Values"/>
				<FIPOKTableAndRadar section="subjectiveCognitiveValues" title="Subjective Cognitive Values"/>
			</ResultJSON>
		</Box>
	);
};
